<template>
    <el-container>
        <el-main>
            <!-- 步骤条展示 -->
            <el-steps :active="activeStep" v-if="dataList" direction="vertical">
                <el-step v-for="(item) in dataList" :key="item.serviceRecordResponse.id">
                    <!-- 用户信息 -->
                    <template #title>
                        <div class="data-title">
                            <span>{{ item.serviceRecordResponse.userName }} | {{ item.serviceRecordResponse.userMobile
                                }}</span>
                            <!-- <el-button @click="callPhone(item.serviceRecordResponse.userMobile)"
                                icon="el-icon-phone"></el-button> -->
                        </div>
                        <!-- 服务留言 -->
                        <div class="data-title reply-section">
                            <strong>{{item.serviceRecordResponse.titleDescribe}}</strong>: {{item.serviceRecordResponse.content}}
                        </div>

                        <!-- 图片展示 -->
                        <div v-if="item.joinsWorkPicList.length > 0">
                            <viewer :images="item.joinsWorkPicList">
                                <img v-for="src in item.joinsWorkPicList" :src="src.url" :key="src.id" />
                            </viewer>
                        </div>
                        
                        <!-- 时间 -->
                        <div class="data-time">服务日记上传时间:{{ formatTime(item.serviceRecordResponse.createTime) }}</div>
                        <!-- 评论部分 -->
                        <div v-if="item.childList.length > 0" class="comments">
                            <!-- 日记评论 -->
                            <strong>日记评论:</strong>
                            <div v-for="(reply, replyIndex) in item.childList" :key="replyIndex" class="comment-item">
                                <strong>{{ reply.realName }}:</strong>
                                <span>{{ reply.content }}</span>&nbsp;
                                <span class="comment-time">{{ formatTime(reply.createTime) }}</span>
                            </div>
                        </div>
                    </template>
                </el-step>
            </el-steps>
            
            <!-- 无数据时显示 -->
            <div v-else class="no-data">
                <p>暂无数据</p>
            </div>
        </el-main>
    </el-container>
</template>

<script>
import { findServiceRecordListOther } from "@/api/work/eliveryOrder";

export default {
    data() {
        return {
            dataList: [], // 服务记录列表
            replyContent: "", // 回复内容
            activeStep: 0, // 当前步骤
        };
    },
    methods: {
        formmaterImage(row) {
            let str = new Array();
            JSON.stringify(row);
            if (row != null) {
                let picArray = row.split(",");
                for (let i = 0; i < picArray.length; i++) {
                    str.push(picArray[i]);
                }
            }
            return str;
        },
        // 获取服务记录
        fetchServiceRecords() {
            let id = this.$route.query.id;
            let data = {
                id,
                clientType: 'JOINS_ENGINEER'
            };
            findServiceRecordListOther(data).then((res) => {
                this.dataList = JSON.parse(res.data);
                console.log('this.dataList::: ', this.dataList);
            });
        },

        // 拨打电话
        callPhone(phone) {
            window.location.href = `tel:${phone}`;
        },

        // 图片预览
        previewImage(url) {
            // 这里可以根据需要实现图片预览功能
            window.open(url, "_blank");
        },

        // 格式化时间戳
        formatTime(timestamp) {
            const date = new Date(timestamp);
            return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}`;
        },

        // 更新回复内容
        updateReplyData(item) {
            this.replyContent = item.content;
        },

        // 提交回复
        submitReply(item) {
            if (!this.replyContent.trim()) {
                this.$message.error("请输入回复内容");
                return;
            }
            // 调用API提交回复
            const replyData = {
                serviceRecordId: item.serviceRecordResponse.id,
                replyContent: this.replyContent,
            };
            this.submitReplyToApi(replyData); // 真实API调用
        },

        // 联系工程师
        contactEngineer() {
            // 假设我们打开一个联系方式页面
            window.location.href = `mailto:${this.engineerName}@example.com`; // 替换为真实邮箱
        },
    },

    created() {
        this.fetchServiceRecords();
    },
};
</script>

<style scoped>
.data-list {
    margin-top: 20px;
}

.data-title {
    font-size: 16px;
    font-weight: bold;
}

.data-time {
    font-size: 12px;
    color: #999;
}
img{
    width: 100px;
    height: 100px;
}
.image-preview {
    width: 100%;
    height: auto;
    cursor: pointer;
}

.comments {
    margin-top: 20px;
}

.comment-item {
    font-size: 14px;
}

.comment-time {
    font-size: 12px;
    color: #999;
}

.reply-section {
    margin-top: 20px;
}

.submit-btn {
    margin-top: 10px;
}

.no-data {
    text-align: center;
    font-size: 16px;
    color: #999;
}

.engineer-info {
    margin-top: 20px;
    border-top: 1px solid #e4e4e4;
    padding-top: 10px;
}
</style>